import api from './service/api.service';

export const requestAccountDeletion = async (data: { email: string }) => {
  const targetUrl = '/v1/mail/request-account-deletion';

  return await api.post<void>(targetUrl, data);
};
